import React, {useRef, useState} from 'react'
import Typography from '@material-ui/core/Typography';
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import clsx from "clsx";
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import {makeStyles} from "@material-ui/core";
import VS from "constants/ValidationShema";
import TextInput from "../../TextInput";
import Loading from "../../Loading";
import UploadFile from "../../UploadFile";
import Box from "@material-ui/core/Box";
import MultiButton, {createButton} from "../../popup/components/MultiButton";
import Chip from "../../Chip";
import getObjectValue from "../../../libs/getObjectValue";
import CorrespondenceService from "../../../services/CorrespondenceService";
import isResponseValid from "libs/isResponseValid";
import PublishMessageConfirmationPopup, {createConfirmObject} from "./PublishMessageConfirmationPopup";
import useSnackbar from "hooks/useSnackbar";
import TypographyWithIcon from "../../TypographyWithIcon";
import InfoIcon from "@material-ui/icons/Info";
import Button from "components/Button";
import CorrespondenceEmailList from "./CorrespondenceEmailList";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    loading: {
        width: '98%'
    },
    buttonRow: {
        textAlign: "end"
    },
    uploadFile: {
        marginBottom: 20
    },
    chip: {
        width: '100%',
        marginTop: theme.spacing(1),
        "&>.MuiChip-label": {
            width: '100%',
            display: "flex"
        }
    },
    chipLabel: {
        display: "flex",
        width: '100%'
    },
    chipSupplier: {
        display: "block",
        width: "200px",
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(2),
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    chipSubject: {
        fontWeight: "bold",
        flexGrow: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    hidden: {
        opacity: 0,
        transition: 'opacity 0.1s'
    },
    marginLeft: {
        marginLeft: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    dialogContent: {
        position: "relative"
    },
    ctrEmailList: {
        background: theme.palette.background.paper,
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
    },
    ctrEmailListTitle: {
        position: "fixed",
        background: theme.palette.background.paper,
        maxWidth: 900,
        marginTop: theme.spacing(-1)
    }
}));

function AddBulkMessagePopup(
    {
        rfxRoundId,
        listResourceId,
        threadsList,
        selectedThreads,
        onClose = () => {
        },
        formSubmit,
    }) {

    const classes = useStyle();

    const [error, setError] = useState('');
    const [working, setWorking] = useState(false);
    const [publishMessageInfo, setPublishMessageInfo] = useState(null);
    const [contractorEmailList, setContractorEmailList] = useState(null);
    const {enqueueErrorSnackbar} = useSnackbar();
    const [open, setOpen] = useState(true);
    const sendType = useRef('');
    const formId = useId();

    const handleSubmit = (type) => {
        setError('');
        sendType.current = type;
        formSubmit[formId]();
    }

    const cancelPublish = () => {
        setOpen(true);
        setPublishMessageInfo(null);
        setWorking(false);
    }
    const processMessage = (type, message) => {

        if (type === 'send') {
            CorrespondenceService.sendBuyerBulkMessages(rfxRoundId, message, listResourceId)
                .then(handleSaveResponse).catch(() => setWorking(false));
        } else if (type === 'publish') {
            setPublishMessageInfo(null);
            setOpen(true);
            CorrespondenceService.publishBuyerBulkMessages(rfxRoundId, message, listResourceId)
                .then(handleSaveResponse).catch(() => setWorking(false));
        }
    }

    const onSubmit = (message) => {
        setWorking(true);
        const reqMessage = {
            threadIds: [...message.selectedThreadsIds],
            message: {
                attachments: message.attachments,
                contents: message.contents
            }
        }

        if (sendType.current === 'send') {
            processMessage('send', reqMessage);
        } else if ('publish') {
            setPublishMessageInfo(createConfirmObject(message, () => processMessage('publish', reqMessage), cancelPublish));
            setOpen(false);
        }
        sendType.current = '';

    }

    const handleSaveResponse = (response) => {
        if (isResponseValid(response, setError)) {
            setWorking(false);
            onClose(response);
        } else {
            setWorking(false);
        }
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working || !!contractorEmailList));
        buttons.push(createButton(Tr('send_and_publish'), () => handleSubmit('publish'), 'outlined', working || !!contractorEmailList));
        buttons.push(createButton(Tr('send'), () => handleSubmit('send'), undefined, working || !!contractorEmailList));
        return buttons;
    }

    const doDelete = (formikProps, threadId) => {
        const selectedThreadsIds = getObjectValue('selectedThreadsIds', formikProps.values, []);
        formikProps.setFieldValue('selectedThreadsIds', selectedThreadsIds.filter(x => x !== threadId))
    }

    const chipClick = (threadId) => {
        setContractorEmailList([]);
        CorrespondenceService.getBuyerThreadEmailList(rfxRoundId, threadId).then(setContractorEmailList).catch(() => {
            setContractorEmailList(null)
            enqueueErrorSnackbar(Tr("unknown_error_message"));
        })

    }

    const getChips = (formikProps) => {

        const selectedThreadsIds = getObjectValue('selectedThreadsIds', formikProps.values, []);

        return threadsList.filter(x => selectedThreadsIds.indexOf(x.threadId) > -1).map(x => (<Chip
            className={classes.chip}
            labelClassName={classes.chipLabel}
            value={<><span title={Tr("correspondence_email_title")}><span className={classes.chipSupplier}>{x.recipients.map(r => r.name).join(", ")}</span></span><span
                className={classes.chipSubject}>{x.subject}</span></>}
            onDelete={selectedThreadsIds.length > 1 ? () => {
                doDelete(formikProps, x.threadId)
            } : undefined}
            key={x.threadId}
            onClick={() => chipClick(x.threadId)}
        />))
    }

    return (<>
            <Dialog
                title={Tr("correspondence_bulk_answer")}
                open={true}
                maxWidth='md'
                className={clsx({
                    [classes.hidden]: !open,
                })}
                dialogActions={<MultiButton buttons={getButtons()}/>}
            >
                <div className={classes.dialogContent}>
                    <Form
                        initialValues={{
                            contents: "",
                            selectedThreadsIds: [...selectedThreads],
                            attachments: []
                        }}
                        validationSchema={Yup.object().shape({
                            contents: VS.string(),
                            selectedThreadsIds: VS.arrayRequired()
                        })}
                        onSubmit={onSubmit}
                        id={formId}
                    >
                        {(formikProps) => (
                            <GridBlock column>
                                {working && <Loading className={classes.loading}/>}

                                {error && <Typography color='error'>{error}</Typography>}

                                <div>
                                    <Typography className={classes.inlineBlock}>{Tr('correspondence_selected_threads')}:</Typography>
                                    {getChips(formikProps)}
                                </div>


                                <TextInput
                                    id='contents'
                                    formikProps={formikProps}
                                    label={Tr('contents')}
                                    disabled={working}
                                    required
                                    multiline
                                />

                                <Box component="div" className={classes.uploadFile}>
                                    <UploadFile
                                        id='attachments'
                                        formikProps={formikProps}
                                        label={Tr("attachment")}
                                        disabled={working}
                                    />
                                </Box>

                            </GridBlock>
                        )}
                    </Form>
                    {!!contractorEmailList && <div className={classes.ctrEmailList}>
                        <GridBlock alignItems="center" className={classes.ctrEmailListTitle}>
                            <TypographyWithIcon Icon={InfoIcon}>{Tr("correspondence_email_notification_list")}</TypographyWithIcon>
                            <Button onClick={() => setContractorEmailList(null)} disabled={!contractorEmailList.length}
                                    className={classes.marginLeft}>{Tr("close")}</Button>
                        </GridBlock>
                        <div className={classes.marginTop}>
                            {
                                !contractorEmailList.length ? <Loading/> : contractorEmailList.map((x, i) =>
                                    <CorrespondenceEmailList key={i} wrapper={x}/>)
                            }
                        </div>

                    </div>
                    }
                </div>
            </Dialog>
            {!!publishMessageInfo && <PublishMessageConfirmationPopup publishMessageInfo={publishMessageInfo}/>}
        </>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(AddBulkMessagePopup);